export default __webpack_public_path__ + "static/media/turkish-lira.fc849628.svg";